import React, { useEffect, useState } from "react";
import { message, Table } from "antd";
import { get, patch } from "../../api/axios";
import { Pagination } from "antd";
import SearchBar from "../../utils/SearchBar";

const Refunds = () => {
  // render: (role) => (role == null ? "" : role.name),
  const columns = [
    //بيانات الحجز
    // 1
    {
      title: (
        <>
          بيانات الحجز
          <br />
          رقم الحجز
          <br />
          اسم الوحدة
          <br />
          رقم الوحدة
          <br />
        </>
      ),

      render: ({ invoice_id, property }) => (
        <>
          {invoice_id || "-"} <br />
          {property?.name || "-"} <br />
          {property?.id || "-"} <br />
          <br />
        </>
      ),
    },

    //بيانات الضيف
    // 2
    {
      title: (
        <>
          بيانات الضيف
          <br />
          أسم الضيف
          <br />
          البريد الالكتروني
          <br />
          الجوال
          <br />
          رقم الضيف
          <br />
        </>
      ),
      dataIndex: "user",
      render: (user) => {
        const { name, phone, email, id } = user || {};
        return (
          <span>
            {name || "-"}
            <br />
            {email || "-"}
            <br />
            {phone || "-"}
            <br />
            {id || "-"}
          </span>
        );
      },
    },

    //بيانات المضيف
    //3
    {
      title: (
        <>
          بيانات المضيف
          <br />
          الاسم
          <br />
          الجوال
          <br />
          البريد الالكتروني
          <br />
          رقم المضيف
          <br />
        </>
      ),
      dataIndex: "owner",
      render: (owner) => {
        const { name, phone, email, id } = owner || {};

        return (
          <span>
            {name || "-"}
            <br />
            {email || "-"}
            <br />
            {phone || "-"}
            <br />
            {id || "-"}
          </span>
        );
      },
    },

    //بيانات السعر
    //4
    {
      title: (
        <>
          بيانات السعر
          <br />
          طريقة السداد
          <br />
          المدة * السعر
          <br />
          إجمالي السعر
          <br />
          العرض
          <br />
          كود خصم
          <br />
          مبلغ الحجز
          <br />
          رسوم الخدمة
          <br />
          المجموع
        </>
      ),

      render: ({ invoice }) => (
        <>
          {invoice?.payment_method || "-"} <br />
          {invoice?.days_count} * {invoice?.prices?.avg_price} <br />
          {invoice?.prices?.totalPrice} <br />
          {invoice?.prices?.offers_amount || "-"} <br />
          {invoice?.prices?.coupon_amount || "-"} <br />
          {invoice?.prices?.subTotal || "-"} <br />
          {invoice?.prices?.total_service || "-"} <br />
          {invoice?.prices?.totalPrice || "-"}
          <br />
        </>
      ),
    },

    //بيانات الاسترداد
    //5
    {
      title: (
        <>
          بيانات الاسترداد
          <br />
          رقم الاسترداد
          <br />
          تاريخ إلغاء الحجز
          <br />
          وقت إلغاء الحجز
          <br />
          مبلغ الاسترداد
          <br />
          تاريخ الاسترداد
          <br />
          الاسترداد بواسطة
          <br />
          حالة الاسترداد
          <br />
          نوع الاسترداد
        </>
      ),

      render: ({
        id,
        owner,
        created_at,
        amount,
        refunded_at,
        method,
        refunded_by,
        status,
      }) => (
        <>
          {id ? `F${id}` : "-"}
          <br />
          {created_at || "-"}
          <br />
          {amount || "-"}
          <br />
          {refunded_at || "-"}
          <br />
          {refunded_by || "-"}
          <br />
          {status || "-"}
          <br />
          {method || "-"}
          <br />
        </>
      ),
    },

    // بيانات الغاء الحجز
    //6
    {
      title: (
        <>
          بيانات إلغاء الحجز
          <br />
          سبب الالغاء
        </>
      ),
      dataIndex: "comment",
    },

    // بيانات الفاتورة
    //7
    {
      title: (
        <>
          بيانات الفاتورة
          <br />
          تاريخ فاتورة الضيف
          <br />
          رقم فاتورة الضيف
          <br />
          عرض فاتورة الضيف
          <br />
          تاريخ فاتورة المضيف
          <br />
          رقم فاتورة المضيف
          <br />
          عرض فاتورة المضيف
        </>
      ),
      width: "200px",

      render: ({ user, owner }) => (
        <span>
          {user?.invoice?.created_at}
          <br />
          {user?.invoice?.number}
          <br />
          {user?.invoice?.invoice_path ? (
            <a
              className="text-decoration-none"
              target="_blank"
              rel="noreferrer"
              href={user?.invoice?.invoice_path}
            >
              عرض فاتورة الضيف
            </a>
          ) : (
            "-"
          )}
          <br />
          {owner?.invoice?.created_at}
          <br />
          {owner?.invoice?.number}
          <br />
          {owner?.invoice?.invoice_path ? (
            <a
              className="text-decoration-none"
              target="_blank"
              rel="noreferrer"
              href={owner?.invoice?.invoice_path}
            >
              عرض فاتورة الضيف
            </a>
          ) : (
            "-"
          )}
        </span>
      ),
    },

    //الرسوم
    //7
    // {
    //   title: (
    //     <>
    //       الرسوم
    //       <br />
    //       المدفوع من الضيف
    //       <br />
    //       رسوم الخدمة قبل الضريبة
    //       <br />
    //       ضريبة القيمة المضافة(الرسوم)
    //       <br />
    //       (الرسوم شامل الضريبة)
    //       <br />
    //       مبلغ الحجز
    //       <br />
    //     </>
    //   ),

    //   render: ({ invoice }) => (
    //     <>
    //       {"-"} <br />
    //       {"-"} <br />
    //       {"-"} <br />
    //       {"-"} <br />
    //       {"-"} <br />
    //       <br />
    //     </>
    //   ),
    // },

    //العمولة
    //8
    // {
    //   title: (
    //     <>
    //       العمولة
    //       <br />
    //       مبلغ الحجز
    //       <br />
    //       العمولة
    //       <br />
    //       ضريبة القيمة المضافة
    //       <br />
    //       العمولة شامل الضريبة
    //       <br />
    //       صافي مبيعات المضيف
    //       <br />
    //     </>
    //   ),

    //   render: ({ invoice }) => (
    //     <>
    //       {"-"} <br />
    //       {"-"} <br />
    //       {"-"} <br />
    //       {"-"} <br />
    //       {"-"} <br />
    //       <br />
    //     </>
    //   ),
    // },

    // {
    //   title: " بيانات الوحدة ",
    //   dataIndex: "property",
    //   render: (property) => {
    //     const { name, code } = property || {};
    //     return (
    //       <span>
    //         الوحدة:
    //         <br />
    //         {name || "غير متوفر"}
    //         <br />
    //         كود الوحدة:
    //         <br />
    //         {code || "غير متوفر"}
    //         <br />
    //       </span>
    //     );
    //   },
    // },

    // {
    //   title: (
    //     <>
    //       تاريخ الاسترداد
    //       <br />
    //       مبلغ الاسترداد
    //       <br />
    //       نوع الاسترداد
    //       <br />
    //       الموظف
    //     </>
    //   ),
    //   // dataIndex: "refund_data",
    //   render: ({ refunded_at, amount, method, refunded_by }) => (
    //     <span>
    //       {refunded_at || "-"}
    //       <br />
    //       {amount || "-"}
    //       <br />
    //       {method || "-"}
    //       <br />
    //       {refunded_by || "-"}
    //     </span>
    //   ),
    // },

    // {
    //   title: " الحالة",
    //   dataIndex: "status",
    // },

    {
      title: "تغير الحالة",
      render: ({ status, id }) => (
        <>
          <button
            onClick={() => handleStatus(id)}
            disabled={status === "منفذ" || loadingStates[id]}
            className={`btn ${
              status === "منفذ" ? "btn-primary" : "btn-warning"
            }  py-0`}
          >
            {loadingStates[id]
              ? "Loading..."
              : status === "منفذ"
                ? "منفذ"
                : "قيد التنفيذ"}
          </button>
        </>
      ),
    },
  ];

  const [data, setdata] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedValue, setDebouncedValue] = useState(searchQuery);

  const [total, setTotal] = useState(1);

  const [loadingStates, setLoadingStates] = useState({});
  const handleStatus = (id) => {
    setLoadingStates((prev) => ({ ...prev, [id]: true })); // Set loading for the specific button
    patch(`refunds/${id}`, {}, {})
      .then((res) => {
        message.success("تم تغيير الحالة بنجاح");
        setdata(res?.data.data);
      })
      .catch((error) => {
        message.error("حدث خطأ أثناء تغيير الحالة");
      })
      .finally(() => {
        setLoadingStates((prev) => ({ ...prev, [id]: false }));
      });
  };
  useEffect(() => {
    get(`refunds?search=${searchQuery}`).then((res) => {
      setdata(res?.data.data);
      setTotal(res?.data.meta.last_page);
      setLoading(false);
    });
  }, [debouncedValue]);

  const handlePagination = (pageNumber) => {
    setLoading(true);

    get(`refunds?page=${pageNumber}`).then((res) => {
      setdata(res?.data.data);
      setLoading(false);
    });
  };

  return (
    <div>
      <div className="row">
        <SearchBar
          setSearchQuery={setSearchQuery}
          searchQuery={searchQuery}
          debouncedValue={debouncedValue}
          setDebouncedValue={setDebouncedValue}
        />
        <div className="col-12 grid-margin stretch-card">
          <div className="w-100">
            <Table
              locale={{ emptyText: "لا يوجد عناصر" }}
              loading={loading}
              pagination={false}
              bordered
              scroll={{
                y: "65vh",
                x: 1750,
              }}
              columns={columns}
              dataSource={data}
              size="middle"
            />
            <Pagination
              defaultCurrent={1}
              className="mt-4 d-flex align-items-center justify-content-center"
              position="bottomCenter"
              total={total * 10}
              onChange={handlePagination}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Refunds;
